export default __webpack_public_path__ + "static/media/battery_icon.b345c3a1.svg";